import {
  normalizeContactPhone,
  resolveCustomerContact,
} from "@/modules/common/utils/customer-contact";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";

const useTelephoneConfig = () => {
  const { lead } = useLeadInfo();

  const contacts = lead?.data?.lead?.lead_telephones ?? [];
  const contact = resolveCustomerContact(
    contacts,
    lead?.data?.lead?.do_not_call,
  );

  const phoneRecords = contacts
    .filter((t) => {
      const kind = resolveCustomerContact([t]).kind;
      return kind === "phone" || kind === "unverified-phone";
    })
    .map((t) => ({ ...t, telephone: resolveCustomerContact([t]).label }));
  const phones = phoneRecords.filter((t) => normalizeContactPhone(t.telephone));
  const primaryTelephone =
    phones.find((t) => t.primary) ??
    phones[0] ??
    (contact.kind === "unverified-phone"
      ? (phoneRecords.find((t) => t.primary) ?? phoneRecords[0])
      : undefined);
  const otherNumbers = phoneRecords.filter((t) => t !== primaryTelephone);
  const remainingNumbersCount = otherNumbers.length;
  const hasMoreThanOneTelephone = otherNumbers.length > 0;

  return {
    primaryTelephone,
    contact,
    contacts,
    remainingNumbersCount,
    hasMoreThanOneTelephone,
    otherNumbers,
  };
};

export default useTelephoneConfig;
